import { Controller } from '@hotwired/stimulus'

const COOLDOWN = 90

export default class extends Controller {
  static targets = ['button', 'countdown']

  connect() {
    this.start()
  }

  disconnect() {
    this.stop()
  }

  start() {
    this.remaining = COOLDOWN
    this.disable()
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  tick() {
    if (this.remaining <= 0) {
      this.stop()
      this.enable()
      return
    }

    this.countdownTarget.textContent = `(${this.remaining}s)`
    this.remaining -= 1
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  disable() {
    this.buttonTarget.disabled = true
    this.buttonTarget.classList.remove('text-primary', 'hover:underline', 'cursor-pointer')
    this.buttonTarget.classList.add('text-base-content/40', 'cursor-not-allowed')
  }

  enable() {
    this.buttonTarget.disabled = false
    this.buttonTarget.classList.remove('text-base-content/40', 'cursor-not-allowed')
    this.buttonTarget.classList.add('text-primary', 'hover:underline', 'cursor-pointer')
    this.countdownTarget.textContent = ''
  }
}
